import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./DeleteProfile.css";

function DeleteProfile({ user }) {
  const [statusMessage, setStatusMessage] = useState("");
  const navigate = useNavigate();

  const handleDeleteRequest = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/delete_type`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: user }),
        }
      );
      if (response.ok) {
        setStatusMessage(`Delete request successfully sent for ${user}.`);
      } else {
        const errorData = await response.json();
        setStatusMessage(errorData.error || "Error processing delete request.");
      }
    } catch (error) {
      setStatusMessage("An error occurred. Please try again.");
    }
  };

  const handleNavigateToLogin = () => {
    navigate("/loginuser");
  };

  return (
    <div className="delete-profile">
      <h2>Request Profile Deletion</h2>
      <p>
        You are requesting to delete your profile associated with the email{" "}
        <strong>{user || "Not logged in"}</strong>. Once requested, your profile
        will be marked for deletion. Note:
      </p>
      <ul>
        <li>
          Your contributions and identifications may still be retained for data
          integrity purposes.
        </li>
        <li>
          All personal information, such as your profile and contact details,
          will be removed after confirmation.
        </li>
        <li>
          The account and data deletion process may take up to 7 business days.
        </li>
        <li>
          If you wish to request account deletion without logging in, please use
          the "Contact Us" link in the footer and describe the issue.
        </li>
        <li>
          You will receive a confirmation email once your account and data
          deletion request has been processed.
        </li>
        <li>
          Please ensure that all outstanding transactions or actions are
          completed before requesting account deletion.
        </li>
        <li>
          After deletion, you may not be able to recover any of your data or
          account information.
        </li>
        <li>
          If you change your mind after initiating account deletion, please
          contact us within 48 hours to cancel the request.
        </li>
        <li>
          For security purposes, you may be asked to verify your identity before
          completing the deletion process.
        </li>
        <li>
          If you have any subscriptions or services linked to your account,
          please ensure they are canceled prior to deletion to avoid further
          charges.
        </li>
      </ul>
      {user ? (
        <button onClick={handleDeleteRequest} className="delete-button">
          Confirm Delete Request
        </button>
      ) : (
        <button onClick={handleNavigateToLogin} className="login-button">
          Go to Login
        </button>
      )}
      {statusMessage && <p className="status-message">{statusMessage}</p>}
    </div>
  );
}

export default DeleteProfile;
